<div class="warning-popup">

  <div class="warning-card">

<div class="warning-header">
  <span class="warning-icon">⚠</span>
  <h2>Report Warnings</h2>
  <mat-icon class="close-icon" (click)="closeModal()">close</mat-icon>
</div>

<div class="warning-body">
  <div class="warning-item" *ngFor="let warn of warnings">
    <div class="warning-title">{{ warn.label }}</div>
    <div class="warning-message">{{ warn.message }}</div>
  </div>
</div>

<div class="warning-actions">
  <button class="btn-secondary" (click)="closeModal()">OK</button>
  <button class="btn-primary" (click)="proceedAnyway()">Proceed Anyway</button>
</div>


  </div>

</div>
